import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CrmOption } from '@touch4it/ng-swp/common';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { CrmLayoutV2ProviderToken } from '@touch4it/ng-swp/layout-v2';

import { ProfilesApiService } from '~/api/profiles/profiles-api.service';
import { UsersApiService } from '~/api/users/users-api.service';

export class WorkspacesSelectorProvider {
  private profiles = inject(ProfilesApiService);
  private user = inject(UsersApiService);
  private router = inject(Router);
  private provider = inject(CrmLayoutV2ProviderToken);

  /* eslint-disable @typescript-eslint/member-ordering */
  readonly workspace = toSignal(this.profiles.currentWorkspaceNamespace$);
  readonly addAllowed = toSignal(this.user.user$.pipe(map(({ roles }) => roles.admin ?? false)), {
    initialValue: false,
  });
  readonly collapsed = this.provider.siderLeftControl.collapsed;

  protected workspaces$ = toObservable(this.profiles.workspaces);
  /* eslint-enable @typescript-eslint/member-ordering */

  getWorkspaces$(): Observable<CrmOption[]> {
    return this.workspaces$.pipe(
      map((data) => {
        return (data ?? []).map(({ name, namespace }) => ({
          value: namespace,
          label: name,
        }));
      }),
    );
  }

  setWorkspace(workspace: string) {
    this.profiles.setCurrentWorkspace(workspace);
    this.router.navigate([workspace]).then(() => {
      window.location.reload();
    });
  }

  workspaceAction(action: 'profile' | 'new') {
    this.router.navigate([this.profiles.currentWorkspace$.value?.namespace, 'workspace', action]).then();
  }
}
